<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header [icon]="['SIDEMENUES', 'STATISTICS', 'SOURCES_SUMMARY'] | monIcons"
             [header]="'Traffic Sources Summary' | translate"
             [subHeader]="'View data for the selected period.' | translate"
             [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <statistics-date-picker (onApply)="updateDateRange()" [(date)]="date" dateRangeGroup="statistics" class="pull-right"></statistics-date-picker>
    </page-header-content>
</page-header>
<mon-spinner [loading]="loading">
    <div class="card panel-monsido-card">
        <div class="card-body pt-0">
            <statistics-summary-general [hidePageviews]="true"
                                        [startDate]="date.startDate"
                                        [endDate]="date.endDate"
                                        (onClick)="setChartData($event.type)"
                                        class="visitor-summary">
            </statistics-summary-general>
            <mon-chart-bar [height]="300"
                       [data]="lineChartData"
                       [labels]="lineChartLabels"
                       [series]="lineChartSeries"
                       [colors]="lineChartColors"
                       [override]="lineChartOverride"
                       [options]="lineChartOptions"
            ></mon-chart-bar>
        </div>
    </div>
</mon-spinner>
<div class="row">
    <div class="col-48 mt-10 block-referring-information">
        <p class="mb-4 header-block" translate>Referring Information</p>
        <mon-spinner [loading]="loading">
            <div class="row d-flex flex-wrap align-items-stretch">
                <div class="col-md-24 col-48">
                    <statistics-sources-summary-block-referring-information [header]="itemReferringInformation.externalReffering.header"
                                                                            [headerIcon]="itemReferringInformation.externalReffering.headerIcon"
                                                                            [footer]="itemReferringInformation.externalReffering.footer"
                                                                            [labels]="itemReferringInformation.externalReffering.labels"
                                                                            [hint]="itemReferringInformation.externalReffering.hint"
                                                                            [content]="itemReferringInformation.externalReffering.data"
                                                                            [totalVisits]="totalVisits"
                                                                            [footerUrl]="itemReferringInformation.externalReffering.footerUrl">
                    </statistics-sources-summary-block-referring-information>
                </div>
                <div class="col-md-24 col-48">
                    <statistics-sources-summary-block-referring-information [header]="itemReferringInformation.searchEngines.header"
                                                                            [headerIcon]="itemReferringInformation.searchEngines.headerIcon"
                                                                            [footer]="itemReferringInformation.searchEngines.footer"
                                                                            [labels]="itemReferringInformation.searchEngines.labels"
                                                                            [hint]="itemReferringInformation.searchEngines.hint"
                                                                            [content]="itemReferringInformation.searchEngines.data"
                                                                            [totalVisits]="totalVisits"
                                                                            [footerUrl]="itemReferringInformation.searchEngines.footerUrl">
                    </statistics-sources-summary-block-referring-information>
                </div>
                <div class="col-md-24 col-48 mt-5">
                    <statistics-sources-summary-block-referring-information [header]="itemReferringInformation.social.header"
                                                                            [headerIcon]="itemReferringInformation.social.headerIcon"
                                                                            [footer]="itemReferringInformation.social.footer"
                                                                            [labels]="itemReferringInformation.social.labels"
                                                                            [hint]="itemReferringInformation.social.hint"
                                                                            [content]="itemReferringInformation.social.data"
                                                                            [totalVisits]="totalVisits"
                                                                            [footerUrl]="itemReferringInformation.social.footerUrl">
                    </statistics-sources-summary-block-referring-information>
                </div>
                <div class="col-md-24 col-48 mt-5">
                    <statistics-sources-summary-top-keywords [startDate]="date.startDate" [endDate]="date.endDate"></statistics-sources-summary-top-keywords>
                </div>
            </div>
        </mon-spinner>
    </div>
</div>